import { render, staticRenderFns } from "./layout-chat-main-v2.vue?vue&type=template&id=fff290b4&scoped=true"
import script from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
export * from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-main-v2.vue?vue&type=style&index=0&id=fff290b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff290b4",
  null
  
)

export default component.exports